(function () {
  'use strict';

  angular.module('ringbaPortal').component('callerBlockingForm', {
    bindings: {
      blockedNumber: '<', //used in edit mode only
      campaigns: '<',
      onDismiss: '&',
      onFormSubmit: '&'
    },
    controller: CallerBlockingFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/caller-blocking/caller-blocking-form.view.html'
  });

  function CallerBlockingFormController(
    accountsService,
    blockedNumberService,
    moment,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.onSubmit = onSubmit;

    function onInit() {
      if (vm.blockedNumber) {
        _initBlockedNumberForEdit();
        return;
      }
      vm.blockMethod = 'specific';
      vm.blockedNumber = {
        blockAllCampaigns: true,
        blockAnonymousCallers: false
      };
    }

    function onSubmit() {
      if (vm.blockedNumber) {
        vm.blockedNumber.blockAnonymousCallers = false;
        if (vm.blockMethod === 'anonymous') {
          vm.blockedNumber.blockAnonymousCallers = true;
        }
        if (vm.blockMethod === 'prefix' && !_.endsWith(vm.blockNumberPrefix, '*')) {
          vm.blockedNumber.phoneNumber = vm.blockNumberPrefix + '*';
        }

        if (!vm.blockedNumber.id) {
          return _addBlockedNumber(vm.blockedNumber);
        } else {
          return _updateBlockedNumber(vm.blockedNumber);
        }
      }
    }

    function _addBlockedNumber(blockedNumber) {
      return blockedNumberService.saveBlockedNumber(accountsService.currentAccountId, blockedNumber).then(function () {
        toaster.pop('success', 'Number successfully blocked');
        vm.onFormSubmit({ blockedNumber: null });
      }).catch(utils.errorHandler);
    }

    function _updateBlockedNumber(blockedNumber) {
      return blockedNumberService.updateBlockedNumber(accountsService.currentAccountId, blockedNumber).then(function () {
        toaster.pop('success', 'Blocked Number settings successfully updated');
        vm.onFormSubmit({ blockedNumber: blockedNumber });
      }).catch(utils.errorHandler);
    }

    function _initBlockedNumberForEdit() {
      vm.blockedNumber = angular.copy(vm.blockedNumber);
      vm.blockedNumber.blockAllCampaigns = !vm.blockedNumber.campaignId;
      vm.blockedNumber.enableBlockTimePeriod = !!vm.blockedNumber.timeLimited;
      vm.blockedNumber.blockAnonymousCallers = vm.blockedNumber.phoneNumber.indexOf('anonymous') > -1;
      if (vm.blockedNumber.timeLimited) {
        const expInHour = moment(vm.blockedNumber.createdDate).diff(vm.blockedNumber.expiration, 'hours', true);
        try {
          vm.blockedNumber.expInHour = _.round(expInHour < 0 ? -expInHour : expInHour.upp);
        } catch {
          // empty
        }
      }
      if (vm.blockedNumber.blockAnonymousCallers) {
        vm.blockMethod = 'anonymous';
      } else if (_.endsWith(vm.blockedNumber.phoneNumber,'*')) {
        vm.blockMethod = 'prefix';
        vm.blockNumberPrefix = vm.blockedNumber.phoneNumber.slice(0, -1);
      }else {
        vm.blockMethod = 'specific';
      }
    }
  }
})();
